<template>
  <div class="row">

    <div class="col-12">
      <form @submit.prevent="postForm">
        <div class="form-row">
          <div class="form-group col-12">
            <input v-model="formdata.acf.firma" type="text" class="form-control" id="firma"
                   placeholder="Firma">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-2">
            <select v-model="formdata.acf.anrede" type="text" class="form-control" id="anrede"
                    placeholder="Anrede">
              <option>Frau</option>
              <option>Herr</option>
              <option>Divers</option>
            </select>
          </div>
          <div class="form-group col-md-5">
            <input v-model="formdata.acf.vorname" type="text" class="form-control" id="vorname"
                   placeholder="Vorname *" required="required">
          </div>
          <div class="form-group col-md-5">
            <input v-model="formdata.acf.name" type="text" class="form-control" id="name"
                   placeholder="Name *" required="required">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-10">
            <input v-model="formdata.acf.strasse" required="required" type="text" class="form-control" id="street"
                   placeholder="Straße *">
          </div>
          <div class="form-group col-md-2">
            <input v-model="formdata.acf.hausnummer" type="text" class="form-control" id="hausnummer"
                   placeholder="Nr.">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <input v-model="formdata.acf.plz" type="text" required="required" class="form-control" id="plz"
                   placeholder="PLZ *">
          </div>
          <div class="form-group col-md-6">
            <input v-model="formdata.acf.ort" type="text" required="required" class="form-control" id="ort"
                   placeholder="Ort *">
          </div>
        </div>
        <div class="form-group">
          <input v-model="formdata.acf.telefon" type="text" class="form-control" id="phone"
                 placeholder="Telefonnummer *" required="required">
        </div>
        <div class="form-group">
          <input v-model="formdata.acf.email" type="email" class="form-control" id="email"
                 placeholder="E-Mail Adresse *" required="required">
        </div>

        <div class="form-group">
          <input v-model="formdata.title" type="text" class="form-control" id="subject"
                 placeholder="Betreff">
        </div>

        <div class="form-group">
          <label for="text">Ihr Anliegen *</label>
          <textarea v-model="formdata.content" id="text" required="required" class="form-control" rows="5"></textarea>
        </div>
        <br>
        <div class="elem-group">
          <label for="captcha">Bitte füllen Sie das Captcha korrekt aus *</label>
          <br>
          <img :src="themeBase + '/ajax/captcha.php?captcha_value='+captcha" alt="CAPTCHA"
               class="captcha-image">
          <br><br>
          <input type="text" id="captcha" required="required" v-model="formdata.captcha"
                 pattern="[A-Z]{6}">
          <br>
        </div>
        <br>
        <div id="abschicken">
          <button class="btn btn-secondary">Abschicken</button>
        </div>
      </form>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ApplyForm',
  props: {
    webid: String,
    captcha: String,
    themeBase: String,
  },
  data() {
    return {
      formdata: {
        title: '',
        content: ' ',
        acf: {
          'webid': "",
          'firma': "",
          'anrede': "",
          'vorname': "",
          'name': "",
          'strasse': "",
          'hausnummer': "",
          'plz': "",
          'ort': "",
          'telefon': "",
          'email': "",
        },
      },
    }
  },
  methods: {
    postFile(event) {
      this.formdata.acf.medien_uploads.push({
        "mediendatei": event.target.files[0].name,
        "beschreibung": encodeURI(this.themeBase +
            '/get_media.php?webid=' +
            this.webid + '&fid=' +
            event.target.files[0].name)
      })
      this.$emit("postFile", event)
    },
    postForm() {
      this.formdata.acf.webid = this.webid
      this.$emit("postForm", this.formdata);
    },
  },
  mounted() {
    console.log('mounted')
    this.formdata.acf.webid = this.webid
  }
}
</script>

<style>
.input-file {
  display: none;
}
</style>
